import { c124kegtap } from './c124kegtap.svg';
import { c1sink1618 } from './c1sink1618.svg';
import { gasolineCutout } from './gasoline-cutout.svg';
import { logInsert } from './log-insert.svg';
import { mokVentsBack } from './mok-vents-back.svg';
import { mokVentsSide } from './mok-vents-side.svg';
import { outletSingleGang } from './outlet-single-gang.svg';
import { outletSingleGangHorizontal } from './outlet-single-gang-horizontal.svg';
import { passthroughVent } from './passthrough-vent.svg';
import { popUpOutlet } from './pop-up-outlet.svg';
import { umbrellaCutout } from './umbrella-cutout.svg';
import { ComponentDynamicSvg } from '../../public.types';

const componentSvgMap: Record<string, ComponentDynamicSvg> = {
	c124kegtap,
	c1sink1618,
	gasolineCutout,
	logInsert,
	mokVentsBack,
	mokVentsSide,
	outletSingleGang,
	outletSingleGangHorizontal,
	passthroughVent,
	popUpOutlet,
	umbrellaCutout
};

export const getSvgData = (svgName: string): ComponentDynamicSvg => {
	return componentSvgMap[svgName];
};
